import styled from 'styled-components';

export const TableContainer = styled.div`
  height: 100%;
  height: 380px;
  margin-top: 1rem;

  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus,
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
  }
  .MuiCheckbox-colorPrimary.Mui-checked {
    color: #671ea7;
  }

  .MuiDataGrid-menuIconButton .MuiIconButton-label .MuiSvgIcon-fontSizeSmall {
    display: none;
  }
`;

export const NavButton = styled.button`
  float: right;
  padding: 8px 8px 8px 8px;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  transition: 0.4s;
  color: #424242;

  &:hover {
    background-color: #f4f5f7;
    color: #000;
    transition: 0.4s;
  }
  &:focus {
    outline: 0;
  }
  svg {
    color: green !important;
  }
`;
